import * as React from "react";

function TelIcon(props) {
  return (
    <svg viewBox="0 0 24.79 18.16" {...props}>
      <g data-name="Layer 2">
        <path
          d="M7.79 3.53H4.9L6 6.39a1.05 1.05 0 01.11.48c0 .24-.11.43-.46.51l-4.9.84C.27 8.27 0 8 0 7.46c0-1.18.16-3.77 1.46-4.77C3.72.94 6.68 0 12.4 0s8.67.94 10.94 2.69c1.29 1 1.45 3.59 1.45 4.77 0 .54-.27.81-.75.76l-4.91-.84c-.35-.08-.46-.27-.46-.51a1.05 1.05 0 01.11-.48l1.11-2.86H17v1.72c0 1.89 1.22 3.29 3.21 5.23a8.5 8.5 0 012.48 6.42c0 .86-.32 1.26-1.24 1.26H3.34c-.91 0-1.24-.4-1.24-1.26a8.5 8.5 0 012.48-6.42c2-1.94 3.21-3.34 3.21-5.23zm9.13 8.62a4.53 4.53 0 10-4.52 4.53 4.52 4.52 0 004.52-4.53zm-2.23-8.62h-4.58v2.59h4.58z"
          fill="#333"
          data-name="Layer 1"
        />
      </g>
    </svg>
  );
}

const MemoTelIcon = React.memo(TelIcon);
export default MemoTelIcon;
